import React from "react";
import { Link } from "react-router-dom";
import { LocationDescriptor } from "history";

import { DeviceReference, DeviceByTypeData } from "modules/devices";
import { Heading2 } from "components/Heading2";

import { AggregatedDeviceStats } from "./AggregatedDeviceStats";
import { AggregatedDeviceStatus } from "./AggregatedDeviceStatus";

export const OptionalLink = ({
  to,
  className,
  children,
  ...props
}: {
  to: LocationDescriptor<unknown> | undefined;
  className: string;
  children: React.ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return to ? (
    <Link to={to} className={className} {...props}>
      {children}
    </Link>
  ) : (
    <div className={className}>{children}</div>
  );
};

export const AggregatedDeviceCard = ({
  title,
  linkTo,
  dataTestId,
  devices,
  deviceData,
  getNow,
  quickLinks,
  alwaysFullWidth = false,
  isUnit = false,
}: {
  title: string;
  linkTo?: string;
  dataTestId?: string;
  devices: DeviceReference[];
  deviceData: DeviceByTypeData[];
  getNow: () => number;
  quickLinks?: React.ReactNode;
  alwaysFullWidth?: boolean;
  isUnit?: boolean;
}) => {
  return (
    <div
      className={`px-2 w-full ${alwaysFullWidth ? "" : "md:w-1/2 lg:w-1/3"}`}
    >
      <div className="rounded-lg shadow-sm bg-white mb-6">
        <OptionalLink
          to={linkTo}
          className={`block px-6 py-4 ${linkTo ? " hover:bg-gray-200" : ""}`}
          data-testid={dataTestId}
        >
          <Heading2 className="font-bold text-xl mb-2">
            {title}
            <AggregatedDeviceStatus
              devices={devices}
              deviceData={deviceData}
              getNow={getNow}
            />
          </Heading2>
          <AggregatedDeviceStats
            getNow={getNow}
            deviceData={deviceData}
            isUnit={isUnit}
          />
        </OptionalLink>
        {quickLinks &&
          React.Children.toArray(React.Children.only(quickLinks)).filter(
            (x) => x
          ).length > 0 && (
            <div className="px-6 py-4 border-t border-gray-200 flex items-center">
              {quickLinks}
            </div>
          )}
      </div>
    </div>
  );
};
